<ng-container [formGroup]="form">
  <ng-container formArrayName="modifiers" *ngIf="formArray.length">
    <ng-container *ngFor="let item of items let i = index;">
      <div class="picker-list__item">
        <div class="picker-item" [formGroupName]="i" [ngClass]="{'is-disabled': isCheckMinMaxRestrictions && !item.restrictions.maxQuantity}">
          <div class="picker-item__label h4">{{ item.name }}</div>
          <div class="picker-item__right">
            <ng-container *ngIf="{price: item.prices | outletPrice | async} as data">

              <ng-container *ngIf="data.price && data.price !== 0 && item.balance !== 0">
                <div class="picker-item__price" *ngIf="!isFree(item, formArray.controls[i].controls['freeQuantity'].value)">
                  <app-price [price]="data.price"></app-price>
                </div>
                <div class="picker-item__price is-free" *ngIf="isFree(item, formArray.controls[i].controls['freeQuantity'].value)">
                  +<app-price [price]="0"></app-price>
                </div>
              </ng-container>

              <div class="picker-item__price is-free" *ngIf="item.balance === 0">
                <span i18n="@@NotAvailable">Not available</span>
              </div>
            </ng-container>
            <div class="picker-item__ctrl" *ngIf="item.balance !== 0">
              <app-counter
                formControlName="quantity"
                [isDisabled]="isCheckMinMaxRestrictions && !item.restrictions.maxQuantity"
                [min]="isCheckMinMaxRestrictions ? item.restrictions.minQuantity : 0"
                [isLockAdd]="isOverflow"
                [max]="isCheckMinMaxRestrictions ? item.restrictions.maxQuantity : 0"
                (changeValue)="onChangeCount()"
              ></app-counter>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
